export const LOGO_URL = "/royce-logo.png";
export const FTC_LOGO_URL = "/ftc-logo.png";
export const CONTACT_EMAIL = "info@royce-international.com";

export const NAV_LINKS = [
  { label: "Collections", target: "collections" },
  { label: "Sold", target: "sold" },
  { label: "Bespoke", target: "bespoke" },
  { label: "Fees", path: "/pricing" },
  { label: "About", target: "about" },
  { label: "Contact", target: "contact" },
];

export const CATEGORY_META = {
  automotive: {
    slug: "automotive",
    title: "Automotive",
    tagline: "Rare automobiles sourced through our exclusive international network.",
    image: "https://images.unsplash.com/photo-1635975229704-0a420e777a56",
  },
  aviation: {
    slug: "aviation",
    title: "Aviation",
    tagline: "Business jets and helicopters available through confidential mandates.",
    image: "https://images.pexels.com/photos/28776068/pexels-photo-28776068.jpeg",
  },
  yachting: {
    slug: "yachting",
    title: "Yachting",
    tagline: "Luxury yachts selected for discerning buyers.",
    image: "https://images.unsplash.com/photo-1597609490757-5fc92ead5cb1",
  },
  "real-estate": {
    slug: "real-estate",
    title: "Real Estate",
    tagline: "Off Market properties in the world's most prestigious locations.",
    image: "https://images.pexels.com/photos/13203179/pexels-photo-13203179.jpeg",
  },
};

export const SEARCH_TYPES = ["Automotive", "Aviation", "Yachting", "Real Estate", "Other"];

export const BUDGET_RANGES = ["€1M – €5M", "€5M – €20M", "€20M – €50M", "€50M +", "Undisclosed"];

export const TIMEFRAMES = ["Immediately", "Within 3 months", "Within 6 months", "This year", "No fixed timeline"];

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
